<template>
  <div id="router" :style="viewStyle">
    <v-app-bar absolute id="app-bar" color="#81C0E2" style="height: 64px" elevate-on-scroll scroll-target="#scrolling-techniques-7">
      <div class="d-inline-block" style="width:160px" @click="redirectPath('/login')">
        <v-img :src="images.new_logo" width=280 alt="中華企業資源規劃學會LOGO"></v-img>
      </div>
    </v-app-bar>
    <v-row class="ma-0" style="height:64px">
    </v-row>
    <div id="box" class="pa-5" style="margin-top:3%">
      <v-row class="pb-5">
        <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
        <h4 class="DarkBlue pt-1">考試資訊確認</h4>
      </v-row>
      <v-row class="mx-2">
        <v-col class="pa-0 col-12 col-md-6">
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>場次代碼</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.examNo"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證考區</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-select class="text_field" dense readonly background-color="#F4F8F9" outlined style="-webkit-text-fill-color: #000"
              :items="frontendAreaList" item-text="title" item-value="valuev" v-model="datasets.frontendArea">
                <template v-slot:append>
                  <v-icon></v-icon>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證考場</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="companyInfo"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證日期</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="examDate"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>繳費方式</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="payGroup"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="pa-0 col-12 col-md-6">
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證項目</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.class1"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證模組</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.class2"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證廠商</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.class3"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證費用</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.examFee"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2">
            <!-- <v-col cols="2" class="py-0 pl-0"> -->
              <div class="text-right pt-1 ml-0 pt14" style="line-height:1.2"><span class="start">*</span>報名繳費截止日期</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="deadline"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div id="box" class="pa-5 mt-3">
      <v-row class="pb-5">
        <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
        <h4 class="DarkBlue pt-1">考試資訊確認</h4>
      </v-row>
      <v-row class="mx-2">
        <v-col class="pa-0 col-12 col-md-6">
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>中文姓名</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense outlined placeholder="請輸入" maxlength="50" v-model="memberInfo.name"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>羅馬拼音</div>
            </v-col>
            <v-col class="col-7 col-md-6">
              <v-text-field class="text_field" dense background-color="white" outlined placeholder="請務必填寫正確護照姓名，若需修正需付費申請" maxlength="50" v-model="memberInfo.englishName"
              @keyup="memberInfo.englishName = memberInfo.englishName.replace(/[\u4e00-\u9fa5]/ig,''), memberInfo.englishName = $Global.toCDB(memberInfo.englishName)"></v-text-field>
            </v-col>
            <v-col class="col-3 col-md-2 pa-0 pt-2 ml-n2">
              <a href="https://www.boca.gov.tw/sp-natr-singleform-1.html" target="_blank" class="pt14">同護照</a>
            </v-col>
          </v-row>
          <v-row class="ma-0 py-1">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>國籍</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0 pt-2 pl-5">
              <v-radio-group class="ma-0 pa-0" dense v-model="memberInfo.citizenShip">
                <v-row>
                  <v-radio v-for="(data,index) in citizenShipList" :key="index" :value = "(index+1).toString()" class="pr-2" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">{{data.title}}</span>
                    </template>
                  </v-radio>
                </v-row>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>身分證字號(ID)</div>
            </v-col>
            <!-- <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense outlined v-model="memberInfo.idCard"></v-text-field>
            </v-col> -->
            <v-col class="py-0 col-7 col-md-6">
              <v-text-field class="border pt14" dense background-color="white" outlined placeholder="請輸入身分證或護照號碼" maxlength="50" v-model="memberInfo.idCard"></v-text-field>
            </v-col>
            <v-col class="col-3 col-md-2 pa-0 pt-1">
              <v-icon v-if="isIdCardOk" color="#81E285" size="30">mdi-check-all</v-icon>
              <v-icon v-else color="#E28181" size="30">mdi-close</v-icon>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>出生年月日</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y left min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense outlined background-color="white" readonly class="text_field datePicker" placeholder="請選擇"
                    v-model="memberInfo.birthday" append-icon="icon-plan_calendar" v-bind="attrs" v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker ref="picker" v-model="memberInfo.birthday" no-title scrollable
                  :max="new Date().toISOString().substr(0, 10)" :picker-date="pickerDate" @change="$refs.menu.save(memberInfo.birthday)"
                ></v-date-picker>
              </v-menu>
              <!-- <v-text-field class="text_field" dense outlined v-model="memberInfo.birthday"></v-text-field> -->
            </v-col>
          </v-row>
          <v-row class="ma-0 py-1">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>性別</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0 pt-2 pl-5">
              <v-radio-group class="ma-0 pa-0" dense v-model="memberInfo.gender">
                <v-row>
                  <v-radio class="pr-2" value="0" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">女</span>
                    </template>
                  </v-radio>
                  <v-radio class="pr-2" value="1" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">男</span>
                    </template>
                  </v-radio>
                  <v-radio class="pr-2" value="2" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">不提供</span>
                    </template>
                  </v-radio>
                </v-row>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>電子信箱</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <email-auto-complete ref="EmailAutoComplete" :onCompletion='(val) => memberInfo.email = val' :domains='mailCandidateList'>
                <input class="emailAutoComplete" type="text" placeholder="請輸入電子信箱" maxlength="50" v-model='memberInfo.email'
                @keyup="[$refs.EmailAutoComplete.check($event), memberInfo.email= memberInfo.email.replace(/[\u4e00-\u9fa5]/ig,''), memberInfo.email = $Global.toCDB(memberInfo.email)]" />
              </email-auto-complete>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>學校類別</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇學校類別" :items="collegeCategoryList" item-text="title" item-value="valuev" v-model="memberInfo.collegeCategory"></v-select>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>學校/單位名稱</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-autocomplete v-if="memberInfo.collegeCategory!='4'" class="text_field autocomplete" placeholder="請選擇學校名稱"
              :items="schoolList" item-text="name" item-value="name" v-model="memberInfo.company"></v-autocomplete>
              <v-text-field v-if="memberInfo.collegeCategory=='4'" class="text_field" dense background-color="white" outlined placeholder="請輸入單位名稱" maxlength="50" v-model="memberInfo.company"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>系所/部門</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入系所/部門" maxlength="50" v-model="memberInfo.department"></v-text-field>
            </v-col>
          </v-row>
        </v-col>

        <v-col class="pa-0 col-12 col-md-6">
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14">聯絡電話</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense background-color="white" outlined placeholder="02-0000-0000" maxlength="30" v-model="memberInfo.tel"
                @keyup="memberInfo.tel = memberInfo.tel.replace(/[\u4e00-\u9fa5]/ig,'') && memberInfo.tel.toUpperCase(), memberInfo.tel = $Global.toCDB(memberInfo.tel)"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>行動電話</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense background-color="white" outlined placeholder="0900000000" maxlength="10" v-model="memberInfo.ctel"
              @keyup="[memberInfo.ctel= memberInfo.ctel.replace(/\D/g,'')]"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0" v-if="memberInfo.citizenShip=='1' || !memberInfo.citizenShip">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>郵遞區號</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined placeholder="自動顯示" v-model="memberInfo.zipCode"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>通訊地址</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-row class="px-3" v-if="memberInfo.citizenShip=='1' || !memberInfo.citizenShip">
                <v-select class="text_field mr-2" dense background-color="white" outlined style="width:48%" placeholder="請選擇縣市" :items="countryList" item-text="country" item-value="country" v-model="memberInfo.country"></v-select>
                <v-select class="text_field" dense background-color="white" outlined style="width:48%" placeholder="請選擇行政區" :items="areaList" item-text="area" item-value="area" v-model="memberInfo.area"></v-select>
              </v-row>
              <v-row class="px-3">
                <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入詳細地址" maxlength="200" v-model="memberInfo.address"></v-text-field>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 py-1">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>企業徵才用</div>
            </v-col>
            <v-col class="col-10 col-md-8 pt-2 pl-5">
              <v-radio-group class="ma-0 pa-0" dense v-model="memberInfo.recruitmentAgree">
                <v-row class="mr-0 pa-0">
                  <v-radio class="pr-2" value="1" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">同意</span>
                    </template>
                  </v-radio>
                  <v-radio class="pr-2" value="0" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">不同意</span>
                    </template>
                  </v-radio>
                  <div class="ma-0 pa-0" @mouseenter="mouseInfor=1" @mouseout="mouseInfor=0">
                    <v-icon style="background:#FFF">mdi-alert-circle-outline</v-icon>
                  </div>
                  <div v-if="mouseInfor==1" class="mt-n2 px-2 border absolute" style="width:220px; height:96px">
                    <h4 class="px-2 pt-3" style="font-size:12pt">※ 已同意將個資提供中華企業資源規劃學會使用</h4>
                    <h4 class="px-2 pb-3" style="font-size:12pt">我願意被企業徵才查詢</h4>
                  </div>
                </v-row>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="ma-0 py-1">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>報考身份別</div>
            </v-col>
            <v-col class="col-10 col-md-8 pt-2 pl-5">
              <v-radio-group class="ma-0 pa-0" dense v-model="examMemberType">
                <v-row>
                  <v-radio class="pr-2" value="1" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">一般</span>
                    </template>
                  </v-radio>
                  <!-- <v-radio v-if="memberInfo.memberType=='erpTeacher' && memberInfo.memberStatus=='0'" class="pr-2" value="3" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">老師</span>
                    </template>
                  </v-radio> -->
                  <v-radio class="pr-2" value="4" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">身心障礙</span>
                    </template>
                  </v-radio>
                  <v-radio class="pr-2" value="5" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">低收入戶</span>
                    </template>
                  </v-radio>
                  <v-radio class="pr-2" value="6" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">其他</span>
                    </template>
                  </v-radio>
                </v-row>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>收據抬頭</div>
            </v-col>
            <v-col class="col-10 col-sm-6 col-md-5">
              <v-text-field class="text_field" dense outlined placeholder="請輸入收據抬頭" maxlength="50" v-model="receiptTitle"
              :readonly="(sameName==true)" :background-color="(sameName == true)?'#F4F8F9':'#FFF'">
              </v-text-field>
            </v-col>
            <v-col class="col-8 col-sm-4 col-md-3 pt-1">
              <v-checkbox class="ma-0 pa-0" v-model="sameName">
                <template v-slot:label>
                  <span class="pt14" style="color:#000000">與中文姓名同</span>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mx-2">
        <v-col class="px-0 col-2">
          <div class="text-right pt-2 pt14"><span class="start">*</span>職稱</div>
        </v-col>
        <v-col v-if="memberType!='erpTeacher'" class="col-10 py-0 pt-2 pl-5">
          <v-radio-group class="ma-0 pa-0" dense v-model="memberInfo.jobtitle">
            <v-row>
              <v-radio class="pr-2" value="1" color="#215DA7">
                <template v-slot:label>
                  <span class="pt14" style="color:#000000">高中生(含五專)</span>
                </template>
              </v-radio>
              <v-radio class="pr-2" value="2" color="#215DA7">
                <template v-slot:label>
                  <span class="pt14" style="color:#000000">大學生</span>
                </template>
              </v-radio>
              <v-radio class="pr-2" value="3" color="#215DA7">
                <template v-slot:label>
                  <span class="pt14" style="color:#000000">碩士生</span>
                </template>
              </v-radio>
              <v-radio class="pr-2" value="4" color="#215DA7">
                <template v-slot:label>
                  <span class="pt14" style="color:#000000">博士生</span>
                </template>
              </v-radio>
              <v-radio class="pr-2" value="5" color="#215DA7">
                <template v-slot:label>
                  <span class="pt14" style="color:#000000">教師</span>
                </template>
              </v-radio>
              <v-radio class="pr-2" value="6" color="#215DA7">
                <template v-slot:label>
                  <span class="pt14" style="color:#000000">社會人士</span>
                </template>
              </v-radio>
            </v-row>
          </v-radio-group>
        </v-col>
        <v-col v-if="memberType=='erpTeacher'" class="col-10 col-md-4 py-0">
          <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入職稱" maxlength="50" v-model="memberInfo.jobtitle"></v-text-field>
        </v-col>
      </v-row>
    </div>

    <v-row class="mx-0 pa-0 my-6" justify="center">
      <v-btn class="ma-1 loginBack col-9 col-sm-4 col-md-4 col-lg-3" outlined style="height:40px; background:#FFFFFF; border-radius:8px; border: 1px solid #81c0e2"
      @click="backPage()">
        <span style="color:#81c0e2">返回登入頁</span>
      </v-btn>
      <v-btn v-if="datasets.applyStatus == '1'" class="ma-1 loginBack col-9 col-sm-4 col-md-4 col-lg-3" outlined style="height:40px; background:#81c0e2; border-radius:8px; border: none"
      @click="checkInformation()">
        <span style="color:#FFFFFF">快速報名</span>
      </v-btn>
    </v-row>

    <ShowMsg ref="ShowMsg" :onSave="onShowMsg"/>
    <ShowConfirm ref="ShowConfirm" :onSave="onShowConfirm"/>
    <SubmitRegistration ref="SubmitRegistration" :onSave="newDataset"/>
  </div>
</template>

<script>
import EmailAutoComplete from "vue-email-autocomplete";
import "vue-email-autocomplete/dist/vue-email-autocomplete.css";
import ShowMsg from '@/dialogs/ShowMsg'
import ShowConfirm from '@/dialogs/ShowConfirm'
import SubmitRegistration from '@/dialogs/SubmitRegistration'
export default {
  name: 'fastRegistration',
  components: {EmailAutoComplete, ShowMsg, ShowConfirm, SubmitRegistration},
  mounted(){
    this.$Global.getCitizenShipList().then(res=>{ this.citizenShipList = res })
    this.$Global.getMailCandidateList().then(res=>{ this.mailCandidateList = res })
    this.$Global.getCollegeCategoryList().then(res=>{ this.collegeCategoryList = res })
    this.$Global.getCountryList().then(res=>{ this.countryList = res })
    this.$Global.getFrontendAreaList().then(res=>{ this.frontendAreaList = res })
    this.getDataset()
    setTimeout(() => { this.initDone = true; }, 1000); //delay 1s
    sessionStorage.setItem('fastRegistration', 'true')
  },
  data:() => ({
    images:{
      new_logo: require('@/assets/image/erp_logo.png'),
    },
    datasets: [],
    memberInfo: {citizenShip:'1', idCard:''},
    orderBy:'id',
    viewStyle:{},
    mouseInfor:0,
    pagination:{page:1,totalPage:10,totalCount:10},
    memberType:'',
    initDone: false,
    isIdCardOk:false,
    idCardInfo: [],
    menu: false,
    pickerDate:(new Date().getFullYear()-20) + '-1-1',

    citizenShipList: [],
    mailCandidateList: [],
    collegeCategoryList: [],
    schoolList: [],
    countryList: [],
    areaList: [],
    frontendAreaList: [],
    classItemClass3List: [],
    feeTypeList: [],
    companyInfo:'', //合併company + examClassroom
    payGroup:'', //轉換
    examDate:'', //合併examDate + examTime
    deadline:'', //合併deadlineDate + deadlineTime

    receiptTitle:'',
    examination:'',
    examMemberType:'',
    // feeType:'',
    havePay:'',
    sameName:false,
    requiredField:['name','englishName','idCard','birthday','gender','email','collegeCategory','company','department','ctel','address','recruitmentAgree','jobtitle'],
    requiredFieldOther:['zipCode','country','area'],
    urlExamNo:''
  }),
  created(){
    this.urlExamNo = decodeURIComponent(window.location.href.replace('https://register.cerps.org.tw/Apply/#/fastRegistration?examNo=','').replace('http://localhost:8080/#/fastRegistration?examNo=','').replace('%20','+').replace('%20','+').replace('%20','+').replace('%20','+').replace('%20','+').replace('%20','+'))
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
    let self = this
    window.onresize = function windowResize () {
      // console.log('window.innerHeight: ' + window.innerHeight)
      self.$root.$emit('windowInnerHeight', window.innerHeight)
    }
  },
  watch:{
    menu (val) {
      val && setTimeout(() => (
        this.$refs.picker.activePicker = 'YEAR',
        this.pickerDate = null
      ))
    },
    "memberInfo.citizenShip":function(){
      this.memberInfo.idCard = ''
    },
    "memberInfo.idCard":function(){
      if(this.memberInfo.citizenShip == '1'){
        if(this.memberInfo.idCard.length == 10){
          this.memberInfo.idCard = this.memberInfo.idCard.toUpperCase();
          this.$Global.checkIdCard(this.memberInfo.idCard).then(res=>{ this.isIdCardOk = res })
          this.$Global.getIdCardInfo(this.memberInfo.idCard).then(res=>{ this.idCardInfo = res })
          return
        }
        this.isIdCardOk = false
      }
      if(this.memberInfo.citizenShip == '2'){
        if(this.memberInfo.idCard.length > 5 && this.memberInfo.idCard.length <= 18){
          this.$Global.checkChinaIdCard(this.memberInfo.idCard).then(res=>{ this.isIdCardOk = res })
          return
        }
        this.isIdCardOk = false
      }
      if(this.memberInfo.citizenShip == '3'){
        if(this.memberInfo.idCard.length > 5 && this.memberInfo.idCard.length <= 20){
          this.$Global.checkPassport(this.memberInfo.idCard).then(res=>{ this.isIdCardOk = res })
          return
        }
        this.isIdCardOk = false
      }
    },
    "memberInfo.collegeCategory":function(){
      this.$Global.getSchoolList(this.memberInfo.collegeCategory, true).then(res=>{ this.schoolList = res })
    },
    "memberInfo.country":function(){
      if(this.initDone){
        this.memberInfo.zipCode = ''
      }
      this.$Global.getAreaListByCountryList(this.memberInfo.country).then(res=>{ this.areaList = res })
    },
    "memberInfo.area":function(){
      this.memberInfo.zipCode = this.$Global.getZipCode(this.areaList, this.memberInfo.area, this.memberInfo.zipCode)
    },
    "sameName":function(){
      if(this.sameName == true){
        this.receiptTitle = this.memberInfo.name
      }
    },
    "examMemberType":function(){
      // 以報考身份別改變認證費用
      if(this.examMemberType === '1'){
        this.havePay = this.datasets.examFee
      } else {
        this.havePay = this.$Global.getHavePay(this.classItemClass3List,this.datasets.class3,this.examMemberType)
      }
    },
  },
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight + 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
    getDataset(){
      var self = this
      var request = {
        method: 'POST',
        url: '/common/erpExamAvailableList',
        data: this.Qs.stringify({
          page: self.pagination.page,
          limit: 10,
          order: self.orderBy,
          examNo: self.$Global.decrypt(self.urlExamNo),
        })
      }
      this.$http(request).then(function(response) {
        self.datasets = response.data.data.data[0]
        if(self.datasets.exportStatus =='4'){
          self.companyInfo = self.datasets.company
        }else{
          self.companyInfo = self.datasets.company + '-' + self.datasets.examClassroom
        }
        self.payGroup = (self.datasets.payGroup=='1') ? '團體繳費': (self.datasets.payGroup=='2') ? '個人繳費': ''
        self.examDate = self.datasets.examDate + ' ' + self.datasets.examTime
        self.deadline = self.datasets.deadlineDate + ' ' + self.datasets.deadlineTime
        self.$Global.getClassItemClass3List(self.datasets.class1, self.datasets.class2).then(res=>{ self.classItemClass3List = res })
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Frn-7956')
        // alert("報名繳費截止日。");
        this.$refs.ShowMsg.open(0,'連結失效','請確認您的QRcode',true ,true)
      }).finally(()=>{
        if(self.datasets.applyStatus != '1'){
          this.$refs.ShowMsg.open(0,'報名已截止','報名繳費已截止，如需報名該場次請聯繫學會人員，謝謝。',true ,true)
          return
        }else if(new Date() >= new Date(self.deadline)){
          this.$refs.ShowMsg.open(0,'報名已截止','報名繳費已截止，如需報名該場次請聯繫學會人員，謝謝。',true ,true)
          return
        }
      })
    },
    checkInformation(){
      const hasInvalidChars = /[\u4e00-\u9fa5ㄅ-ㄩ]/g.test(this.memberInfo.englishName);
      if (hasInvalidChars) { 
        this.$refs.ShowMsg.open(0,'請重新輸入','羅馬拼音包含不正確的字元，請重新輸入');
        this.memberInfo.englishName = this.memberInfo.englishName.replace(/[\u4e00-\u9fa5ㄅ-ㄩ]/g, '')
        this.memberInfo.englishName = this.$Global.toCDB(this.memberInfo.englishName)
        return
      }
      if(!this.memberInfo.email.includes('@')){
        this.$refs.ShowMsg.open(5)
        return
      }
      if(!this.isIdCardOk){
        this.$refs.ShowMsg.open(0,'身分證字號錯誤','請再次確認您的身分證字號')
        return
      }
      if(!this.$Global.checkForm(this.memberInfo,this.requiredField)){
        this.$refs.ShowMsg.open(1)
        return
      }
      if(this.memberInfo.citizenShip=='1' || !this.memberInfo.citizenShip){
        if(!this.$Global.checkForm(this.memberInfo,this.requiredFieldOther)){
          this.$refs.ShowMsg.open(1)
          return
        }
      }
      if(!this.examMemberType || !this.receiptTitle){
        this.$refs.ShowMsg.open(1)
        return
      }
      this.erpExamCheckIdCard()
    },
    erpExamCheckIdCard(){
      var self = this
      var request = {
        method: 'POST',
        url: '/common/erpExamCheckIdCard',
        data: this.Qs.stringify({
          IdCard: self.memberInfo.idCard,
          ExamNo: self.datasets.examNo,
        })
      }
      this.$http(request).then(function(response) {
        if(response.data.data == '未報考'){
          self.$refs.SubmitRegistration.open()
        }
        if(response.data.data == '已報考'){
        self.$refs.ShowMsg.open(0,'系統提示','該身分證已報名該場次，請返回登入頁，登入系統進確認。')
        }
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Frn-9951')
      }).finally(()=>{
      })
    },
    newDataset() {
      this.memberInfo.idCard = this.memberInfo.idCard.trim()
      var msg = ''
      var allData = this.$Global.copy(this.datasets)
      allData = this.$Global.jsonConcat(allData,this.memberInfo)
      allData = this.$Global.jsonConcat(allData,{'examCompany':this.datasets.company})
      allData = this.$Global.jsonConcat(allData,{'receiptTitle':this.receiptTitle})
      allData = this.$Global.jsonConcat(allData,{'sameName':this.sameName})
      allData = this.$Global.jsonConcat(allData,{'examMemberType':this.examMemberType})
      // allData = this.$Global.jsonConcat(allData,{'feeType':this.feeType})
      allData = this.$Global.jsonConcat(allData,{'havePay':this.havePay})
      allData = this.$Global.jsonConcat(allData,{'realPay':this.havePay})
      allData = this.$Global.jsonConcat(allData,{'createId': 'FastRegistration'})
      allData = this.$Global.jsonConcat(allData,{'createTime': this.$options.filters.dateFormat(new Date(),'YYYY-MM-DD HH:mm:ss')})
      var self = this
      var request = {
        method: 'POST',
        url: '/common/erpExamReg',
        data: this.Qs.stringify(allData)
      }
      this.$http(request).then(function(response) {
        console.log(response)
        msg = response.data.msg
        // self.$refs.ShowMsg.open(0,'專案認證報名成功','若為個人繳費，請點選左列報名資訊查詢>前往繳費，進行繳款 ! 考前三天將發送通知簡訊，請您留意考試相關訊息 !',true)
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','報名失敗，請聯繫系統管理人員，編號為Frn-7957')
      }).finally(()=>{
        if(msg == "重複報名相同時段場次"){
          this.$refs.ShowMsg.open(0,'系統提示','重複報名相同時段場次',true ,true)
          return
        }else if(self.idCardInfo.erpMember || self.idCardInfo.erpTeacher){
          this.$refs.ShowMsg.open(0,'快速報名成功','請您登入系統，確認詳細報名資訊及繳費資訊。',true ,true)
        }else{
          this.$refs.ShowMsg.open(0,'快速報名成功','請您以帳號：身分證字號(ID)及預設密碼：出生年月日登入系統，確認詳細報名資訊及繳費資訊。',true ,true)
        } 
      })
    },
    backPage(){
      this.$refs.ShowConfirm.open(0,'返回登入頁','您確定要放棄填寫報名資料並返回登入頁？', true)
    },
    onShowMsg(){
      this.redirectPath('/login')
    },
    onShowConfirm(){
      this.redirectPath('/login')
    },
  }
}
</script>